const Antenna = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1664_92635"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1664_92635)">
      <path
        d="M0.793457 9.99992C0.793457 8.72214 1.03554 7.52603 1.51971 6.41158C2.00373 5.29714 2.66492 4.32339 3.50325 3.49033C4.34158 2.65741 5.31797 1.99971 6.43242 1.51721C7.54686 1.03471 8.73603 0.793457 9.99992 0.793457C11.2638 0.793457 12.453 1.03471 13.5674 1.51721C14.6819 1.99971 15.6582 2.65741 16.4966 3.49033C17.3349 4.32339 17.9961 5.29714 18.4801 6.41158C18.9643 7.52603 19.2064 8.72214 19.2064 9.99992H17.5397C17.5397 8.95825 17.3401 7.98005 16.941 7.06533C16.5418 6.15061 15.9995 5.3513 15.3141 4.66741C14.6285 3.98353 13.8284 3.44471 12.9137 3.05096C11.9989 2.65707 11.0277 2.46012 9.99992 2.46012C8.97214 2.46012 8.00089 2.65707 7.08617 3.05096C6.17144 3.44471 5.3713 3.98353 4.68575 4.66741C4.00033 5.3513 3.45804 6.15061 3.05887 7.06533C2.65971 7.98005 2.46012 8.95825 2.46012 9.99992H0.793457ZM4.12679 9.99992C4.12679 8.36103 4.70283 6.97241 5.85492 5.83408C7.00714 4.69589 8.3888 4.12679 9.99992 4.12679C11.611 4.12679 12.9927 4.69589 14.1449 5.83408C15.297 6.97241 15.873 8.36103 15.873 9.99992H14.2064C14.2064 8.8338 13.7952 7.84123 12.9728 7.02221C12.1503 6.20304 11.1594 5.79346 9.99992 5.79346C8.84047 5.79346 7.8495 6.20304 7.027 7.02221C6.20464 7.84123 5.79346 8.8338 5.79346 9.99992H4.12679ZM7.49992 18.826L6.17387 17.4999L9.052 14.6218V11.9864C8.677 11.803 8.37492 11.5336 8.14575 11.178C7.91658 10.8226 7.802 10.4299 7.802 9.99992C7.802 9.38672 8.01499 8.86707 8.44096 8.44096C8.86707 8.01498 9.38672 7.802 9.99992 7.802C10.6131 7.802 11.1328 8.01498 11.5589 8.44096C11.9848 8.86707 12.1978 9.38672 12.1978 9.99992C12.1978 10.4299 12.0832 10.8226 11.8541 11.178C11.6249 11.5336 11.3228 11.803 10.9478 11.9864V14.6218L13.826 17.4999L12.4999 18.826L9.99992 16.336L7.49992 18.826Z"
        fill="white"
      />
    </g>
  </svg>
);

export default Antenna;
